import { PersonCircle } from 'react-bootstrap-icons';

interface UserIconProps {
    name: string;
    clickfunc: () => void;
}

function UserIcon({name, clickfunc}: UserIconProps){
    return (
        /* Need to write code to capture half stars */
        <> 
            <div className="d-inline-block align-self-end">
                <PersonCircle onClick={clickfunc} size={24} className='py-0 my-0' />
                <p className="smallest-copy-style text-font-body my-0">Account</p>
            </div>
        </>
    )
}

export default UserIcon;